<template>
    <div class="container-activity">
      <MpNavbar active="coffee" />
      <MpTitle title="请核对并导入咖啡豆（Beta）" intro="此页面展示Excel中解析出的咖啡豆" />
      <div class="content-table" v-show="tableData">
        <!-- height="300" :loading="loading" -->
        <vxe-toolbar>
          <template #buttons>
            <vxe-button @click="back()">返回</vxe-button>
            <vxe-button @click="uploadAll()">全部导入</vxe-button>

            <!-- <vxe-button @click="exportDataEvent">下载模板</vxe-button> -->
            <!-- <vxe-button @click="exportDataEvent">导入咖啡豆.xlsx</vxe-button> -->
          </template>
        </vxe-toolbar>
        <vxe-table round border highlight-hover-row resizable :data="tableData">
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <vxe-table-column field="name" title="咖啡豆名称"  width="300"></vxe-table-column>
          <vxe-table-column title="庄园 / 豆种 / 批次">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                    庄园：{{ row.estate || '无' }}
                </div>
                <div class="small-text">
                    豆种：{{ row.kind || '无' }}
                </div>
                <div class="small-text">
                    批次：{{ row.batch || '无' }}
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column title="处理方式 / 烘培程度">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                    处理方式：
                    <span v-if="row.method" v-for="item in constantMethods" >
                      <span v-if="row.method == item.key">
                        {{ item.value }}
                      </span>
                    </span>
                    <span v-if="!row.method">
                      无
                    </span>
                    <span v-if="row.method == 9 && row.customMethod">
                      （{{ row.customMethod }}）
                    </span>
                </div>
                <div class="small-text">
                    烘培程度：
                    <span v-if="row.deep" v-for="item in constantDeep" >
                      <span v-if="row.deep == item.key">
                        {{ item.value }}
                      </span>
                    </span>
                    <span v-if="!row.deep">
                      无
                    </span>
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column  title="国家 / 地区 / 产区">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                    国家：{{ row.country || '无' }}
                </div>
                <div class="small-text">
                    地区：{{ row.region || '无' }}
                </div>
                <div class="small-text">
                    产区：{{ row.prodRegion || '无' }}
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column  title="含水量 / 密度 / 水活性">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                  含水量：{{ row.water ? row.water + '%' : '无' }}
                </div>
                <div class="small-text">
                  密度：{{ row.density || '无' }}
                </div>
                <div class="small-text">
                  水活性：{{ row.waterActivity || '无' }}
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column  title="豆色值 / 粉色值">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                  豆色值：{{ row.color || '无' }}
                </div>
                <div class="small-text">
                  粉色值：{{ row.pink || '无' }}
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column title="操作"  width="110">
            <template #default="{ row, rowIndex }">
              <van-button v-if="row.hasUpload && row.hasUpload == true" disabled color="#999" size="small" round>已导入</van-button>
              <div v-else >
                <!-- <van-button  color="#489D80" size="small" round>编辑</van-button> -->
                <van-button @click="upload(row,rowIndex)" color="#13ACA7" size="small"  style="margin-left: 6px;" round>导入</van-button>
            </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <!-- 弹窗 -->
    </div>
  </template>
  
  <script>
    import MpNavbar from '../../components/mp/navbar'
    import MpTitle from '../../components/mp/title'
    import { apiBeansCreate } from '../../request/api'
    import Vue from 'vue';
    import { Button,Toast } from 'vant';
  
    Vue.use(Button);
  
    export default {
      components: {
        MpNavbar,
        MpTitle
      },
      name: 'Index',
      // props: {
      //   msg: String
      // },
      data() {
        return {
          loading: false,
          tableData: null,
          constantActivityCategory: null,
          constantDeep: null,
          constantMethods: null,
          uploadResult:{
            success: 0,
            fail: 0,
          }
        }
      },
      mounted() {
        console.log(this.$route.params.coffeeInfo)
        this.init()
      },
      methods: {
        init() {
          this.getBeansList()
          this.getConstantDeep()
          this.getConstantMethods()
        },
        back() {
          this.$router.go(-1)
        },
        reflash() {
          this.tablePage = {
            currentPage: 1,
            pageSize: 10,
            totalResult: null
          }
          this.tableData = null
          this.getBeansList()
  
        },
        getBeansList() {
          if(this.$route.params.coffeeInfo){
            let coffeeInfo = this.$route.params.coffeeInfo
            for(let i = 0; i < coffeeInfo.length; i++){
              coffeeInfo[i].hasUpload = false
            }
            this.tableData = this.$route.params.coffeeInfo
          }else{
            this.$router.go(-1)
          }
        },
        // 上传咖啡豆信息
        upload(item,index){
          let self = this
          let params = item
          apiBeansCreate(params).then(res => {
            if(res.code == 0){
              Toast.success('导入成功');
              self.tableData[index].hasUpload = true
            }
          })
        },
        uploadOne(item,index){
          return new Promise((resolve, reject) => {
            let self = this
            let params = item
            apiBeansCreate(params).then(res => {
              if(res.code == 0){
                self.tableData[index].hasUpload = true
                self.uploadResult.success++
                Toast.loading({
                  message: '导入成功 ' + self.uploadResult.success + ' 条',
                  duration: 0
                });
                resolve()
              }
              else{
                self.uploadResult.fail++
                resolve()
              }
            }).catch(err => {
              self.uploadResult.fail++
              resolve()
            })
          })
        },
        async uploadAll(){
          this.uploadResult ={
            success: 0,
            fail: 0,
          }
          for(let i = 0; i < this.tableData.length; i++){
            if(this.tableData[i].hasUpload == false){
              await this.uploadOne(this.tableData[i],i)
              if(i == this.tableData.length - 1){
                Toast.clear()
                Toast.success('导入完成，共导入成功 ' + this.uploadResult.success + ' 条');
                await this.sleep(2000)
              }else{
                await this.sleep(5000)
              }
            }
          }
          Toast.clear()
        },
        sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms))
        },
        // 基础信息
        getConstantDeep(){
          let deep = localStorage.getItem('constantDeep')
        if(deep && deep.length > 0){
          // 字符串转换为json
          this.constantDeep = JSON.parse(deep)
        }else{
          setTimeout(() => {
            this.getConstantDeep()
          }, 500);
        }
        },
        getConstantMethods(){
        let methods = localStorage.getItem('constantMethods')
        if(methods && methods.length > 0){
          this.constantMethods = JSON.parse(methods) 
        }else{
          setTimeout(() => {
            this.getConstantMethods()
          }, 500);
        }
        },
        // 格式化
        formatTime({ cellValue, row, column }) {
          let time = new Date(cellValue)
          let year = time.getFullYear()
          let month = time.getMonth() + 1
          let date = time.getDate()
          let hours = time.getHours()
          let minute = time.getMinutes()
          let second = time.getSeconds()
  
          if (month < 10) { month = '0' + month }
          if (date < 10) { date = '0' + date }
          if (hours < 10) { hours = '0' + hours }
          if (minute < 10) { minute = '0' + minute }
          if (second < 10) { second = '0' + second }
          return year + '.' + month + '.' + date + ' ' + hours + ':' + minute
        },
        formatStste({ cellValue, row, column }) {
          if (cellValue == 1) {
            return "🟢 进行中"
          }
          else if (cellValue == 2) {
            return "🔴 已结束"
          } else {
            return "未知状态"
          }
        },
        formatCups({ cellValue, row, column }) {
          return cellValue + "个"
        },
        formatTable({ cellValue, row, column }) {
          if (cellValue == 1) {
            return "简易杯测表"
          } else if(cellValue == 2){
            return "SCAA杯测表"
          } else if(cellValue == 3){
            return "COE杯测表"
          } else if(cellValue == 4){
            return "世界咖啡冲煮大赛（指定冲煮）感官评分表"
          } else if(cellValue == 5){
            return "世界咖啡烘焙大赛评分表"
          } else if(cellValue == 6){
            return "咖啡饮品感官评分简表"
          } else if(cellValue == 7){
            return "Roster’s Commu.烘焙赛评分表"
          }
          else {
            return "其它"
          }
        },
        formatCategory({ cellValue, row, column }) {
          let result
          for (let index = 0; index < this.constantActivityCategory.length; index++) {
            if (this.constantActivityCategory[index].key == cellValue) {
              result = this.constantActivityCategory[index].value
            }
          }
          return result
        },
        goDetail(uuid) {
          this.go("mp/activity/detail/"+uuid)
        },
        goGather(uuid) {
          this.go("mp/activity/gather/"+uuid)
        },
        go(where) {
          this.$router.push('/' + where)
        },
      }
    }
  </script>
  
  <style scoped>
    .container-activity {
      width: 100%;
      height: 100%;
      overflow: auto;
      position: relative;
      padding-left: 110px;
      padding-top: 30px;
      padding-right: 30px;
      padding-bottom: 30px;
    }
    .small-text {
        font-size: 12px;
        line-height: 1.4;
        color: #999999;
    }
  </style>